import React, { useState, useEffect, useRef } from "react";

import "../../Forms/Form.css";
import "../../../Components/Commons/Commons.css";

import SidebarMenu from "../../../Components/Sidebar/Sidebar";

import backarrow from "../../../Assets/Icons/back-arrow.png";
import "quill/dist/quill.snow.css";
import { useReactToPrint } from "react-to-print";
import Forms from "../Forms";
import { useNavigate } from "react-router-dom";

function MedicalCertificate() {
  const navigateto = useNavigate();

  return (
    <div className="App">
      <SidebarMenu />
      <div className="col p-5 pt-4 manager-container overflow">
        <div className="row pt-2 p-3">
          <div className="col-1 text-center mt-2">
            <img
              src={backarrow}
              alt="back"
              className="backarrow"
              width={25}
              height={25}
              onClick={() => navigateto(-1)}
            ></img>
          </div>
          <div className="col font-big font-bold">MEDICAL CERTIFICATE</div>
        </div>
        <Forms
          formType={"med_cert_general"}
          patientDetails={{
            name: "Vanessa Ibale",
            age: "23",
            sex: "Female",
            diagnosis: "Beautificationism",
          }}
        />
      </div>
    </div>
  );
}
export default MedicalCertificate;
